import React from 'react';
import Link from 'gatsby-link';
import { withRouter } from 'react-router';
import { Scrollbars } from 'react-custom-scrollbars';
import { Helmet } from 'react-helmet';

class TroubleshootingPage extends React.Component {
  render () {
    return (
      <div id="community-rules" className={`page community-rules`}>
        <Helmet>
          <title>Community Rules</title>
          <meta name="description" content={'ParkYou! unites micro-communities of city car owners to instantaneously find street parking. We are launching in Fall 2018. Read our community rules here.'} />
        </Helmet>

        <Scrollbars className="article">
          <h1>Troubleshooting</h1>
          <p>Coming soon!</p>
        </Scrollbars>
      </div>
    )
  }
}

export default withRouter(TroubleshootingPage);
 


// WEBPACK FOOTER //
// ./src/pages/troubleshooting.js